<template>
  <v-container >
    <v-row class="text-center">
      <v-col>
        <h1>TERAS LEGACY SDN BHD</h1>
        <h2>Agency Leader's Contract</h2>
        <br><br>
        <v-btn
          v-show="showForm && !overlayReadAgree"
          @click="showForm = false"
          color="primary"
        >
          Lihat Kontrak
        </v-btn>
        <v-btn
          v-show="!showForm && !overlayReadAgree"
          @click="showForm = true"
          color="primary"
        >
          Isi Butiran
        </v-btn>
        <br><br>
        <v-divider/>

        <v-col v-show="overlayReadAgree" class="mb-4">
          <v-card-text class="text--primary">
            <v-checkbox
              v-model="isAgree"
              label="Saya telah membaca dan bersetuju dengan terma dan syarat yang terkandung di dalam kontrak."
            ></v-checkbox>
          </v-card-text>
                
          <v-btn
            @click="readAndAgree"
            outlined
            :disabled="!isAgree"
          >
            Teruskan
          </v-btn>
        </v-col>

        
        <div
          v-show="showForm"
        >
        <v-form 
          ref="form" 
          @submit.prevent="submit">

          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="date"
                  :rules="rules.name"
                  color="blue darken-2"
                  label="Date"
                  outlined
                ></v-text-field>
                <v-select
                  v-model="month"
                  :items="monthItems"
                  :rules="rules.text"
                  item-text="item" 
                  item-value="value"
                  label="Month"
                  outlined
                ></v-select>
                <v-select
                  v-model="year"
                  :items="yearItems"
                  :rules="rules.text"
                  item-text="item" 
                  item-value="value"
                  label="Year"
                  outlined
                ></v-select>
                <br>
                <v-text-field
                  v-model="name"
                  :rules="rules.name"
                  color="blue darken-2"
                  label="Name"
                  outlined
                  class="text-input"
                ></v-text-field>
                <v-text-field
                  v-model="ic"
                  :rules="rules.name"
                  color="blue darken-2"
                  label="IC Number"
                  outlined
                ></v-text-field>
                <v-text-field
                  v-model="agentCode"
                  :rules="rules.name"
                  color="blue darken-2"
                  label="Agent Code"
                  outlined
                  class="text-input"
                ></v-text-field>
                <br>
                <v-text-field
                  v-model="addressLine1"
                  :rules="rules.name"
                  color="blue darken-2"
                  label="Address"
                  placeholder="Cth: 03-06, Tropika Welcome Centre"
                  hint="Cth: 03-06, Tropika Welcome Centre"
                  outlined
                  class="text-input"
                >
                </v-text-field>
                <v-text-field
                  v-model="addressLine2"
                  :rules="rules.name"
                  color="blue darken-2"
                  placeholder="Cth: 10, Jalan Setia Tropika 1/21, Taman Setia Tropika" 
                  hint="Cth: 10, Jalan Setia Tropika 1/21"
                  outlined
                  class="text-input"
                >
                </v-text-field>
                <v-text-field
                  v-model="addressLine3"
                  color="blue darken-2" 
                  placeholder="Cth: 81200, Johor Bahru, Johor"
                  hint="Cth: 81200, Johor Bahru, Johor"
                  outlined
                  class="text-input"
                >
                </v-text-field>
                <br>
                <v-text-field
                  v-model="branch"
                  :rules="rules.name"
                  color="blue darken-2"
                  label="Branch"
                  outlined
                  class="text-input"
                ></v-text-field>
              </v-col>
            </v-row>
            <br>
            
            <br>
            <v-row justify-md="space-around">
              <v-col sm="12" md="5">
                <v-checkbox
                  v-model="isChecked"
                  label="Sila semak dan email kontrak ini kepada admin@teraslegacy.com"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>

          <v-row justify-md="space-around">
              <v-col sm="6" md="6">
                <p><b>E-signature</b></p>
                <v-btn @click="clearSignCanvas()">Clear</v-btn>
                <br><br>
                <VueSignatureCanvas
                  ref="handWrite"
                  class="sig-canvas pa-5"
                />
              </v-col>
              
            </v-row>

          
        
          <v-btn
            :disabled="!formIsValid"
            color="primary"
            type="submit"
          >
            Submit
          </v-btn>

          <!-- dev code : experiment purpose
          <br><br>
          <v-btn
            color="primary"
            @click="getSize"
          >
            getMonth
          </v-btn>-->

        </v-form>
        


        </div>

        <div 
          v-show="!showForm"
          class="grey col-md-10 mx-auto"
        >
          <vue-pdf-embed :source="pdfUrl" />
        </div>

        
        
        

        <v-overlay :value="overlay">
          <v-card
            class="mx-auto pa-4"
            max-width="344"
            outlined
          > 
            <br>
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            <h3 class="title ma-3">Generating contract</h3>
            <p class="sub-title">Will be downloaded automatically.</p>
            <p> Please check and email to admin@teraslegacy.com after download.</p>
                
            <v-btn
              icon
              @click="overlay = false"
              x-large
            >
              <v-icon>{{mdiClose}}</v-icon>
              Dismiss
            </v-btn>
          </v-card>
        </v-overlay>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import  VueSignatureCanvas  from 'vue-signature-canvas';
import { PDFDocument, StandardFonts } from 'pdf-lib';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import { getDatabase, ref, push } from "firebase/database"
import { dbPaths } from "../assets/dbPaths.js";
import { mdiClose } from '@mdi/js'

export default {
  components: {
    VueSignatureCanvas, 
    VuePdfEmbed, 
  },

  mounted() {
    //console.log('mounted ==');
  },

  data () {
    
    return {
      mdiClose,
      showForm: false, //if false, show contract.
      overlayReadAgree: true,
      isAgree: false,

      //pdfUrl: require('../assets/pdf/agency-leader-contract.pdf'),
      pdfUrl: 'pdf/agency-leader-contract.pdf',

      showCanvas: true,

      date: '',
      month: '',
      year: { item: '', value: '' },
      name: '',
      ic: '',
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      agentCode: '',
      branch: '',

      rules: {
        name: [val => (val || '').length > 0 || 'This field is required'],
      },
      monthItems: ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'],
      yearItems: [
        {
          item: '2019', value: '19'
        },
        {
          item: '2020', value: '20'
        },
        {
          item: '2021', value: '21'
        },
        {
          item: '2022', value: '22'
        },
        {
          item: '2023', value: '23'
        },
        {
          item: '2024', value: '24'
        },
        {
          item: '2025', value: '25'
        },
        {
          item: '2026', value: '26'
        },
        {
          item: '2027', value: '27'
        },
        {
          item: '2028', value: '28'
        },
        {
          item: '2029', value: '29'
        },
        {
          item: '2030', value: '30'
        },
      ],

      overlay: false,
      signImageUrl: '',
      isChecked: false,

    }
  },

  updated() {
    //console.log('updated');
  },

  computed: {
    formIsValid () {
      return (
        this.date && this.month && this.year &&
        this.name && this.ic && this.agentCode && this.addressLine1 && this.addressLine2 && this.addressLine3 && this.branch &&
        !this.$refs.handWrite.isEmpty() && this.isChecked
      )
    },
  },

  methods: {

    // --------- exp code [start] -------------

    

   

    // --------- exp code [end] --------------
    readAndAgree() {
      this.overlayReadAgree = false
      this.showForm = true
    },

    clearSignCanvas() {
      this.$refs.handWrite.clear()
    },

    //....... x-y coordinate formula ..................
    getFinalX(xFromPsd) {
      return (xFromPsd/21) * 612
    },
    getFinalY(yFromPsd) {
      return ((27.20-yFromPsd)/27.20) * 792
    },

    async generatePdf () {
      this.overlay = true  

      this.signImageUrl = this.$refs.handWrite.getCanvas().toDataURL()

      const existingPdfBytes = await fetch(this.pdfUrl).then(res => res.arrayBuffer())
      const pdfDoc = await PDFDocument.load(existingPdfBytes)
      
      const pages = pdfDoc.getPages()
      const page2 = pages[1]
      const page12 = pages[11]
      //const { width, height } = page2.getSize()
      //console.log('w : ' + width + ' | h : ' + height);

      const fontTimesRoman = await pdfDoc.embedFont(StandardFonts.TimesRoman)
      const fontSize = 13

      //page 2
        page2.drawText( this.date, {
          x: this.getFinalX(4.43),
          y: this.getFinalY(6.67),
          size: fontSize,
          font: fontTimesRoman,
        })
        page2.drawText( this.month, {
          x: this.getFinalX(9.90),
          y: this.getFinalY(6.67),
          size: fontSize,
          font: fontTimesRoman,
        })
        page2.drawText( this.year, {
          x: this.getFinalX(14.58),
          y: this.getFinalY(6.67),
          size: fontSize,
          font: fontTimesRoman,
        })

        page2.drawText( this.name.toUpperCase(), {
          x: this.getFinalX(5.10),
          y: this.getFinalY(11.12),
          size: fontSize,
          font: fontTimesRoman,
        })
        page2.drawText( this.ic, {
          x: this.getFinalX(5.10),
          y: this.getFinalY(11.87),
          size: fontSize,
          font: fontTimesRoman,
        })
        page2.drawText( this.agentCode.toUpperCase(), {
          x: this.getFinalX(5.10),
          y: this.getFinalY(12.53),
          size: fontSize,
          font: fontTimesRoman,
        })
        page2.drawText( this.addressLine1.toUpperCase(), {
          x: this.getFinalX(5.10),
          y: this.getFinalY(13.28),
          size: fontSize,
          font: fontTimesRoman,
        })
        page2.drawText( this.addressLine2.toUpperCase(), {
          x: this.getFinalX(5.10),
          y: this.getFinalY(13.99),
          size: fontSize,
          font: fontTimesRoman,
        })
        page2.drawText( this.addressLine3.toUpperCase(), {
          x: this.getFinalX(5.10),
          y: this.getFinalY(14.65),
          size: fontSize,
          font: fontTimesRoman,
        })

        page2.drawText( this.branch.toUpperCase(), {
          x: this.getFinalX(10.20),
          y: this.getFinalY(19.23),
          size: fontSize,
          font: fontTimesRoman,
        })
        
      //page 12
        const pdfByteSignHjWan = await fetch(require('../assets/pdf/sign-hj-wan.png')).then(res => res.arrayBuffer())
        const imgSignHjWan = await pdfDoc.embedPng(pdfByteSignHjWan)
        const pngSignHjWanDims = imgSignHjWan.scaleToFit(198.43, 140.32) //unit used = pt.

        page12.drawText( "MOHD REDZUAN MOHD JAAFAR", {
          x: this.getFinalX(2.48),
          y: this.getFinalY(12.20),
          size: fontSize,
          font: fontTimesRoman,
        })
        page12.drawImage(imgSignHjWan, {
          x: this.getFinalX(12.83),
          y: this.getFinalY(9.53),
          width: pngSignHjWanDims.width,
          height: pngSignHjWanDims.height,
        })

        const imageSign = await pdfDoc.embedPng(this.signImageUrl)
        const pngDims = imageSign.scaleToFit(182.24, 111.97)

        page12.drawText( this.ic, {
          x: this.getFinalX(2.48),
          y: this.getFinalY(17.00),
          size: fontSize,
          font: fontTimesRoman,
        })
        page12.drawText( this.name.toUpperCase(), {
          x: this.getFinalX(2.48),
          y: this.getFinalY(20.22),
          size: fontSize,
          font: fontTimesRoman,
        })

        page12.drawImage(imageSign, {
          x: this.getFinalX(12.83),
          y: this.getFinalY(18.35),
          width: pngDims.width,
          height: pngDims.height,
        })

      //generate pdf.
        const pdfBytes = await pdfDoc.save()
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Leader-Contract-" + this.name + ".pdf";
        link.click();
        URL.revokeObjectURL(link.href);
    },

    submit() {
      const db = getDatabase();
      const date = new Date();

      push(ref(db, dbPaths.toEContract() + date.getFullYear() + '/' + date.getMonth() ), {
        agent_code: this.agentCode.toUpperCase(),
        agent_name: this.name.toUpperCase(),
        date: date.toDateString(),
        time: date.toLocaleTimeString(),
        contract_date: this.date + '/' + this.month + '/' + this.year,
      })
      .then(() => {
        // Data saved successfully!
        
        this.generatePdf()
      })
      .catch((error) => {
        // The write failed...
        console.log(error);
        this.overlay = false
        this.overlayError = true
      });
    },	
      


    //dev code; experiment.
    getMonth() {
      console.log('month : ' + this.year);
    },

    async getSize() {
    /**
     * const pdfDoc = await PDFDocument.load(proposalImages.contract())
        
        const pages = pdfDoc.getPages()
        const page2 = pages[1]
        const { width, height } = page2.getSize()
        console.log('w : ' + width + ' | h : ' + height);
    **/
    }

  },

}
</script>

<style lang="scss">
.hasBorder {
  border-style: solid;
  border-width: 1px;
  border-color:grey;
}

.sig-canvas {
  width: 300px;
  height: 200px;
  background-color: rgba(244,244,244,0);
  border-style: solid;
  border-width: 1px;
}


.text-input input{
  text-transform: uppercase
}
</style>